export const historicalRelationshipNames = [
  'まみよし',
  'Mikasu-Channel',
  'テック好きイシハラさん',
  'きすけ / ガジェットの本音',
  'さがらごうち',
  'ワタナベカズマサ',
  'GADGET LOG',
  'Appleが大好きなんだよ',
  'HOUSE WITH GARAGE',
  '戸田覚：ガジェット【辛口】点数評価',
  '岡ちゃんnel',
  'ホソP channel',
  'たける / たけぷらす。',
  "MiD'S LIFE",
  '美咲みさ / 自作PC 女子',
  'Daiking・ダイキング',
  'Yuji-ライフハック',
  'THE オトウサンノヒミツキチ / お父さんの秘密基地',
  'あっちゃん3110',
  'マメ',
  'dLab channel',
  'すぐる@iPhone・ガジェット',
  'ぺい👟1分でわかるズル賢い一人暮らし',
  'Gadgetouch /ガジェタッチ',
  'じゅん | iPhoneと便利ガジェットのある暮らし',
  'あさひ|1分でマネできる手抜き掃除術',
  'ものこと -ガジェットに囲まれた暮らし-',
]

export const j200RelationshipNames = [
  'Appleが大好きなんだよ',
  'マメ',
  'テック好きイシハラさん',
  'きすけ / ガジェットの本音',
  'こにたく / nikostyle',
  'Apple Watch Journal',
  'ニノ /  MONOTIVE',
  'みーみち',
  'ガジェットモ',
  'ねこしぃの周辺機器',
  '岡ちゃんnel',
  '美咲みさ / 自作PC 女子',
  'すぐる@iPhone・ガジェット',
  'いいもの図鑑',
  'いいもの図鑑📚【ガジェット|ライフ|デジタル】',
]

// Verified aliases whose public channel/account identity matches a tracker row.
export const verifiedRelationshipAliasNames = [
  'AKN GADGET Channel',
  '家電彼女',
  'そると/iPhone便利機能/ガジェット',
]

export const historicalRelationshipSet = new Set(historicalRelationshipNames)
export const j200RelationshipSet = new Set(j200RelationshipNames)
